import { Exclude, Expose } from 'class-transformer';
import { BaseModel } from '../models';
import { BUSINESS_INDUSTRY_SECTOR_APPETITE, BUSINESS_INDUSTRY_SEGMENT } from '../types';

@Exclude()
export class CreateBusinessIndustryDto extends BaseModel {
  @Expose()
  primaryExposureCountryId!: number;

  @Expose()
  secondaryExposureCountryId!: number;

  @Expose()
  counterpartyCode!: string;

  @Expose()
  currentPaidUpCapital!: number;

  @Expose()
  numberOfEmployee!: number;

  @Expose()
  bnmSectorialCode!: string;

  @Expose()
  masSectorialCode!: string;

  @Expose()
  cimbInternalCode!: string;

  @Expose()
  sectorAppetite!: BUSINESS_INDUSTRY_SECTOR_APPETITE;

  @Expose()
  industrySegment!: BUSINESS_INDUSTRY_SEGMENT;

  @Expose()
  capitalType!: string;

  @Expose()
  sharedAllotedAmount!: number;

  @Expose()
  issuedCapitalAmount!: number;

  @Expose()
  currency!: string;

  @Expose()
  metadata!: object;
}
